<!--
 * @Description: 列表中字段编辑状态或者中间态
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<!--
1. 通过父级组件传递过来的参数，
2. 打开蒙层
3. 单机时，本组件高度变化（做滚动条），展示更多数据， 边框变颜色
4. 双击时，本组件高度变化（做滚动条），展示编辑状态 边框变颜色
5. 编辑状态时，给子组件同步状态，各个小组件打开编辑状态
6. 子组件通过回调传递数据，本组件做数据校验是否有改变，
6.点击蒙层，是单击状态直接关闭当前状态，是双击时，校验数据是否修改，修改过保存数据，关闭当前状态，销毁当前组件，同时通过回调同步给父组件，父组件更新数据
7.不可编辑状态，边框和底色是灰色，给子组件同步状态，只读
8. 双击时提示不可编辑提示语，点击蒙层直接关闭当前状态
-->

<template>
  <div ref="editContentRef" :class="['field-edit-content', setCellEditClassName, !getFields?.editable ? 'field-disabled' : setClickType == 2 ? 'field-edit' : '']" @click.stop="handleClick(1)" :style="data.contentListStyle">
    <component :is="getfieldCom[getFields?.fieldType]" ref="fieldEditComRef" :params="getFields" @cb="getFieldsCb" @update="handleClick" :clickType="setClickType" :openSelectModal="setSelectVisible" />
    <!-- loading蒙层 -->
    <div class="mask-content" :style="{ zIndex: 1001 }" v-if="loading">
      <div class="loading-circle"></div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, inject, ref, nextTick, provide, computed, onBeforeUnmount, onUnmounted, watchEffect } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';
import { Message } from '@arco-design/web-vue';
import { fieldsService } from '@/api';
import useEditFields from '@/hooks/edit-field';
import useLoading from '@/hooks/loading';
import useEventListener from '@/hooks/event-listener';
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const { getFieldVal, editField, getEffective, checkFormat, checkRequired, amountPercentFieldTypes, setFieldVal, setWarningMessage, textRightAlign, getfieldCom, selectFieldTypes, textFieldTypes, assemblyParameters, isFixed, setSelectWidth, handleTbodyScroll, setSelectHeight, popTypes } = useEditFields();
const { eventListener } = useEventListener();
const { loading, setLoading } = useLoading(false);
const props = defineProps({
  fields: {
    //字段的信息
    type: Object,
    required: true,
    default: () => {
      return {
        fieldType: 0,
        mainField: false, //是否主属性
        isRequired: true, //必填
        fieldValue: '这是文本',
        fieldExt: '',
        entity: 1, //主对象的entityId
        subEntityId: 1, //子表单的对象entityId
        isBusiness: false, //是否是引用字段
        permissions: 0 //权限默认不可编辑
      };
    }
  },
  clickType: {
    //点击类型
    type: String || Number,
    default: 0
  }
});
const emits = defineEmits(['cb']);
const fieldEditComRef = ref(); //编辑的动态组件
const editContentRef = ref(); //编辑状态容器
const getFields = ref(props?.fields); //字段信息
const getClickType = ref(props.clickType); //点击类型
const setSelectVisible = ref(false); //下拉框显示变量
const setClickType = computed(() => getClickType.value);

let setMinHeight = 35; //编辑容器的最小高度
// const setMaxWidth = 503; //编辑容器的最大宽度
let setMaxHeight = 200; //编辑容器的最大高度
let setTop = 0; //距离顶部位置
let setLeft = 0; //距离左侧位置
let setSelectLeft = 0; //距离左侧位置
let paddingTop = 4; // 编辑容器的padding-top
let paddingBottom = 6; // 编辑容器的padding-bottom
let setWidth = 0; //设置编辑容器的宽度
let remainingWidth = 0; //右侧剩余的空间
let getTbody1; //一级表格
let getTHeaderRect1; //一级表格表头
let getTbodyLevel; //多层级表格
let cellRect; //单元格
const getFieldType = computed(() => getFields.value.fieldType); //字段类型
const tableBodyContainer = inject('fieldEditData')?.tableBodyContainer; //表格的tbody容器

const parentCellClass = computed(() => inject('fieldEditData')?.parentCellClass);

const isMouseDown = inject('fieldEditData')?.isMouseDown;
const updateIsMouseDown = inject('fieldEditData')?.updateIsMouseDown;
const detailsDrawer = inject('rootDrawer')?.detailsDrawer; // 详情页抽屉
const detailsDrawerZIndex = inject('rootDrawer')?.detailsDrawerZIndex; // 详情页抽屉z-index

const getIsMouseDown = computed(() => isMouseDown.value);
const tableLevel = computed(() => getFields.value?.tableLevel);
const isDetailTable = computed(() => getFields.value?.isAssTable); // 详情页表格
const data = reactive({
  zIndex: 1004,
  contentListStyle: {}, //列表样式
  disabledClick: false,
  currentWidthAndSort: inject('defaultParams')?.currentWidthAndSort || {
    k: '',
    sort: ''
  },
  contentWidth: inject('fieldEditData')?.contentWidth,
  columns: inject('defaultParams')?.columns,
  cellRef: inject('fieldEditData')?.cellRef,

  specialFieldTypes: [18, 26], // 特殊字段类型
  setSelectStyle: {
    //下拉框的样式
    left: null,
    right: null,
    maxHeight: 370,
    minHeight: 160
  }
});
// 绑定编辑框的class
const setCellEditClassName = computed(() => `field-edit-content-${parentCellClass.value}`);

//多层级或者详情页的表格
const isMultiLevelOrDetailTable = computed(() => tableLevel.value > 1 || isDetailTable.value);
let oldFieldValue = _.cloneDeep(props.fields);
const stopEffect = watchEffect(() => {
  getFields.value = _.cloneDeep(props?.fields);
  console.log('stopEffect', getFields.value);
  oldFieldValue = _.cloneDeep(props.fields);
  getFields.value.zIndex = isDetailTable.value ? detailsDrawerZIndex.value + 1 : data.zIndex;
});
const handleClickType = ref(false); //单机双击的开关
// 更新点击类型
const updateClickType = (type) => {
  getClickType.value = type;
};
const fieldEditMethods = inject('fieldEditMethods'); //调用父组件方法
const updateEditStatus = //编辑之后把编辑状态恢复
  fieldEditMethods?.updateEditStatus ||
  (() => {
    return '';
  });
// 关闭编辑效果
const handleEsc = (event) => {
  // 检查按下的是否是 ESC 键 (键值为 27)
  if (event.key === 'Escape' || event.keyCode === 27) {
    updateEditStatus();
    event.stopPropagation(); // 阻止事件冒泡
  }
};

eventListener('keydown', handleEsc, window, true);
const getMainTableMethods = inject('mainTableMethods'); //调用main-table父组件方法
const getTableMethods = inject('tableMethods'); //调用table父组件方法
// 获取tbody的rect对象
const getTableBodyRef =
  getMainTableMethods?.getTableBodyRef ||
  (() => {
    return '';
  });

// 获取最后一个固定列的rect对象
const getFixedLeftLastCellRect =
  getTableMethods?.getFixedLeftLastCellRect ||
  (() => {
    return '';
  });
const updateZIndex =
  getTableMethods?.updateZIndex ||
  (() => {
    return '';
  });

// 获取展示的容器
const getShowBodyRef =
  getMainTableMethods?.getShowBodyRef ||
  (() => {
    return '';
  });
const getFixed = ref(false);
//计算左侧，顶部定位位置
const calculateLocation = () => {
  setWidth = data.contentWidth; //编辑容器的宽度
  cellRect = data.cellRef?.getBoundingClientRect();
  getTbody1 = tableBodyContainer.value; //表体
  if (tableLevel.value != 0) {
    //表格
    getTbodyLevel = getShowBodyRef(1) || getTableBodyRef(tableLevel.value || 1) || null; //多层级表格
    if (!getTbody1) return false;
  } else {
    //分组
    getTHeaderRect1 = document.querySelectorAll('.qf-table-header-sticky')?.[0]?.getBoundingClientRect();
    if (!getTbody1 || !getTHeaderRect1) return false;
  }
  const tbody1Rect = getTbody1?.getBoundingClientRect(); //一级表格或者分组表格表体
  setTop = cellRect.top - tbody1Rect.top + getTbody1.scrollTop;
  setLeft = cellRect.left - tbody1Rect.left;

  if (tableLevel.value <= 1) {
    //一级表格，或者分组
    setLeft += getTbody1.scrollLeft;
    remainingWidth = tbody1Rect.width - setLeft; //右侧剩余空间
    if (tableLevel.value == 0) {
      //分组
      remainingWidth = getTHeaderRect1.width - setLeft; //右侧剩余空间
    }
  } else {
    const tbodyLevelRect = getTbodyLevel?.getBoundingClientRect(); //多层级表格表体
    const levelCellLeft = cellRect.left - tbodyLevelRect.left + getTbodyLevel.scrollLeft;
    remainingWidth = tbodyLevelRect.width - levelCellLeft; //右侧剩余空间
  }
};
//   设置下拉框的样式
const setSelectContentStyle = (init, selectWidth = null) => {
  calculateLocation();
  //   const setSpacing = 16; //误差
  //右侧空间不够时
  let getSelectWidth = selectWidth;
  if (init) {
    //初始化
    getSelectWidth = setSelectWidth(getFieldType.value);
  }
  setSelectLeft = setLeft;
  if (getSelectWidth && remainingWidth < getSelectWidth) {
    setSelectLeft = setLeft - getSelectWidth + setWidth;
  }
  data.setSelectStyle.left = setSelectLeft + 'px';
  if (popTypes.value.includes(getFieldType.value)) {
    //日期，日期范围，级联
    data.setSelectStyle.left = setSelectLeft + 'px';
  }
};
const getRichTextValue = async () => {
  setLoading(true);
  try {
    const params = {
      entity: getFields.value?.isSubForm ? getFields.value.subEntityId : getFields.value.entity,
      fieldKey: getFields.value.fieldKey,
      businessId: getFields.value.row.id
    };
    const res = await fieldsService.getFieldValueByEntity(params);
    if (!res?.error) {
      getFields.value.fieldValue = res?.result;
    } else {
      Message.error(res?.error?.msg || t('数据获取失败'));
    }
    setLoading(false);
  } catch (e) {
    console.log(e);
    setLoading(false);
  }
};
// 设置预览编辑容器样式
const setEditContentStyle = async () => {
  // 判断是否固定列
  data.contentListStyle = {};

  setSelectContentStyle(true);
  const setContentPosition = {
    //预览框的定位
    left: isMultiLevelOrDetailTable.value ? setLeft + 'px' : '0px',
    right: null,
    top: isMultiLevelOrDetailTable.value ? setTop + 'px' : '0px'
  };

  if (data.specialFieldTypes.includes(getFieldType.value)) {
    if (getFieldType.value == 26) {
      //兼容富文本ES特殊逻辑
      await getRichTextValue();
    }
    //附件，富文本
    setMaxHeight = 350;
    if (getFieldType.value == 18) {
      paddingTop = 0;
      paddingBottom = 0;
    }
    if ((getFieldType.value == 18 && getFields.value?.fieldValue) || (getFieldType.value == 26 && getFields.value?.fieldValue && getFields.value?.fieldValue != '<p><br></p>')) {
      setMinHeight = 100; //最小高
      setWidth = 450;
      if (getFieldType.value == 18) {
        paddingBottom = 6;
      }

      if (remainingWidth < setWidth) {
        if (isMultiLevelOrDetailTable.value) {
          setContentPosition.left = setLeft - (setWidth - data.contentWidth) + 'px';
        } else {
          setContentPosition.left = null;
          setContentPosition.right = '0px';
        }
      }
    }
  }
  if (textFieldTypes.value.includes(getFieldType.value)) {
    //单行文本 多行文本
    setMaxHeight = 400;
  }

  data.contentListStyle = {
    zIndex: data.zIndex,
    width: setWidth + 'px',
    // maxWidth: setMaxWidth + 'px',
    minHeight: setMinHeight + 'px',
    maxHeight: setMaxHeight + 'px',
    // paddingRight: '1px',
    paddingTop: paddingTop + 'px',
    paddingBottom: paddingBottom + 'px',
    paddingLeft: '14px',
    ...setContentPosition
  };

  if (getFixed.value || tableLevel.value > 1) {
    //多层级表格，固定列z-index为1002
    data.contentListStyle.zIndex = 1002;
  }

  if (textRightAlign(getFields.value)) data.contentListStyle.paddingRight = '8px';

  if (getFieldType.value == 18) {
    data.contentListStyle.paddingLeft = '0px';
  }
  if (getFieldType.value == 26) data.contentListStyle.paddingLeft = '0';
};
// 动态设置下拉框的样式
const setSelectStyleFn = () => {
  const setParames = {
    maxHeight: 370,
    minHeight: 160,
    previewClientHeight: editContentRef.value?.clientHeight + 14,
    getParentStyleTop: setTop,
    getBodyScrollHeight: isDetailTable.value ? window.innerHeight : getTbody1?.scrollHeight //表格的可视高度
  };

  const selectStyleObj = setSelectHeight(setParames);
  data.setSelectStyle.maxHeight = selectStyleObj.maxHeight;
  data.setSelectStyle.minHeight = selectStyleObj.minHeight;
};
// 隐藏遮罩
const closeModal = async () => {
  data.disabledClick = false; //释放防重复点击变量
  if (getFixed.value) {
    updateZIndex({ rowKey: getFields.value.row.id, zIndex: null });
  }

  handleTbodyScroll();
  handleEventListener(0);
  setSelectVisible.value = false;
  updateEditStatus();
};
// 关闭编辑状态
const closable = async () => {
  if (data.disabledClick) return;
  if (setClickType.value == 1 || (setClickType.value == 2 && !getFields.value?.editable)) {
    //不可编辑直接关闭蒙层
    closeModal();
    return false;
  }

  if (getFields.value?.editable && fieldEditComRef.value?.editSave) {
    //保存
    await fieldEditComRef.value?.editSave();
  }
};

// 监听body上的点击事件
const handleBodyClick = (event) => {
  console.log('点击目标为你', event.target.tagName);
  if (getIsMouseDown.value) {
    updateIsMouseDown();
    return; // 忽略由 mousedown 触发的点击
  }
  // 判断点击元素或其父级是否包含特定class
  const isInsideMediaContainer = event.target.closest('.media-select-container') !== null;
  const isEditableCell = event.target.classList.contains(setCellEditClassName.value);
  // 只有既不是可编辑单元格，也不在下拉框的选择容器内时才关闭
  if (!isEditableCell && !isInsideMediaContainer) {
    closable();
  }
};

// body处理绑定事件
const handleEventListener = (type = 0) => {
  const getApp = getFields.value?.isAssTable ? detailsDrawer.value : document.getElementById('app');
  if (type == 1) {
    getApp?.addEventListener('click', handleBodyClick);
  } else {
    getApp?.removeEventListener('click', handleBodyClick);
  }
};
onMounted(async () => {
  handleClickType.value = false;
  await nextTick();
  getFixed.value = isFixed(data.columns, getFields.value);
  if (getFixed.value) {
    //固定列
    updateZIndex({ rowKey: getFields.value.row.id, zIndex: 1003 });
  }
  setEditContentStyle();
  getFields.value.zIndex = isDetailTable.value ? detailsDrawerZIndex.value + 1 : data.zIndex;
  handleEventListener(1);
  handleScroll();
});
// 滚动改变下拉框定位
const onPositionChange = (scrollDistance) => {
  console.log('滚动参数回调', scrollDistance);
  data.setSelectStyle.left = scrollDistance.selectLeft + 'px';
  if (tableLevel.value > 1 || isDetailTable.value) {
    data.contentListStyle.left = scrollDistance.contentLeft + 'px';
  }
};
//单双机事件(type==1)更新编辑下拉框显示状态
const handleClick = async (type) => {
  if (setClickType.value == 1) {
    //进入编辑效果
    const getStatus = setWarningMessage(getFields.value, true);
    // console.log('getStatus-----', getStatus);
    if (getFields.value?.editable && getStatus) {
      //能编辑状态也支持编辑
      getClickType.value = 2;

      if (data.specialFieldTypes.includes(getFieldType.value)) {
        //附件，富文本
        data.contentListStyle.width = 450 + 'px';
        data.contentListStyle.minHeight = 100 + 'px';
        const getWidth = 450;
        if (getFieldType.value == 18 && getFields.value?.fieldValue) {
          data.contentListStyle.paddingBottom = '0px';
        }

        if (remainingWidth < getWidth) {
          if (isMultiLevelOrDetailTable.value) {
            data.contentListStyle.left = setLeft - (getWidth - data.contentWidth) + 'px';
          } else {
            data.contentListStyle.left = null;
            data.contentListStyle.right = '0px';
          }
        }
      }
      if (selectFieldTypes.value.includes(getFieldType.value)) {
        setSelectVisible.value = true;
      }
    } else {
      //不可编辑(不可编辑，单机/双击给提示，再次单机/双击不再给提示)
      if (type == 1 && !handleClickType.value) {
        //单机
        setWarningMessage(getFields.value, false);
        handleClickType.value = true;
      }
    }
  }
  if (setClickType.value == 2 && selectFieldTypes.value.includes(getFieldType.value)) {
    //再次打开下拉框
    setSelectVisible.value = true;
  }
  if (type == 0) {
    //关闭下拉框
    setSelectVisible.value = false;
  }
};
const onClose = () => {
  setSelectVisible.value = false;
};
// 表格滚动事件
const handleScroll = () => {
  const level = tableLevel.value == 0 ? 1 : tableLevel.value; // 多层级表格,或者分组

  const params = {
    fields: getFields.value,
    columns: data.columns,

    contentWidth: data.contentListStyle.width?.split('px')?.[0], //内容宽度
    // contentLeft: data.contentListStyle.left?.split('px')?.[0], //内容的定位
    // selectLeft: data.setSelectStyle.left?.split('px')?.[0], //下拉框的定位
    type: 1,
    onPositionChange: onPositionChange,
    onClose: onClose,
    closeModal: closeModal,
    contentCellClass: setCellEditClassName.value,
    parentCellClass: parentCellClass.value,
    getTableFixedBody: getFixedLeftLastCellRect(level),
    getTbody1, //一级表体
    getTbodyLevel, //多层级
    isAssTable: getFields.value?.isAssTable //是否是详情页的表格
  };
  handleTbodyScroll(params);
};

// 执行emits回调
const handleEmits = (apiParams, fieldParams) => {
  // 金额 百分比 需要单独处理
  const showFieldValue = amountPercentFieldTypes.value.includes(getFieldType.value) ? apiParams.fieldValue : fieldParams.fieldValue;
  const getFieldParams = {
    ...apiParams,
    fieldType: getFieldType.value,
    fieldExt: getFields.value.fieldExt,
    fieldValue: showFieldValue
  };

  const getnewFieldValue = getFieldVal(getFieldParams);

  emits('cb', {
    fieldValue: getnewFieldValue,
    businessId: apiParams.businessId
  });
};
// 保存
const saveFields = async (fieldParams) => {
  try {
    setLoading(true);
    // 通过.分割数组并取最后一个，兼容详情子表单快捷编辑
    const _splitFieldKey = getFields.value.fieldKey?.split('.');
    const _fieldKey = _splitFieldKey?.[_splitFieldKey?.length - 1] || getFields.value.fieldKey;
    const apiParams = {
      entity: getFields.value?.isSubForm ? getFields.value.subEntityId : getFields.value.entity,
      fieldKey: _fieldKey,
      businessId: getFields.value.row.id,
      fieldValue: setFieldVal(fieldParams),
      apiIndex: getFields.value.entity + Math.random()
    };

    // 详情页子表单单字段编辑 需要传递子表单自身的entity
    if (getFields.value?.subEntityId && getFields.value?.isAssTable) {
      apiParams.entity = getFields.value.subEntityId;
    }

    const res = await editField(apiParams);
    setLoading(false);

    if (!res.error) {
      Message.success('保存成功');
      if (fieldParams?.fieldType === 18 && res?.result?.fieldValue) {
        fieldParams.fieldValue = res.result.fieldValue;
      }
      handleEmits(apiParams, fieldParams);
    }
    closeModal(); //关闭蒙层
  } catch (e) {
    console.log(e);
    setLoading(false);
    closeModal(); //关闭蒙层
  }
};

// 获取修改之后的值
const getFieldsCb = async (cbParams) => {
  const getParameters = assemblyParameters(cbParams, {
    ...getFields.value,
    oldFieldValue: oldFieldValue
  }); //组装参数

  // 校验参数有效性
  if (!getEffective(getParameters) || !checkRequired(getParameters) || !checkFormat(getParameters)) {
    closeModal();
    return false;
  }
  //   if (!checkRequired(getParameters)) {
  //     // 必填校验
  //     return false;
  //   }

  //   // 校验格式
  //   if (!checkFormat(getParameters)) {
  //     data.disabledClick = false;

  //     return false;
  //   }

  // 保存字段值
  data.disabledClick = true;
  await saveFields(getParameters);
};
onBeforeRouteLeave(() => {
  closeModal();
});
onBeforeUnmount(() => {
  // 确保在卸载前移除事件监听器
  handleEventListener(0);
  closeModal();
  stopEffect();
});
onUnmounted(() => {
  handleEventListener(0);
});
provide('fieldcontentData', {
  setSelectStyle: computed(() => data.setSelectStyle), //下拉框的样式
  contentWidth: computed(() => setWidth), //编辑单元格的width值
  contentStyleWidth: computed(() => setSelectLeft), //编辑单元格的left值
  remainingWidth: computed(() => remainingWidth), //当前单元格右侧剩余的空间
  contentStyleTop: computed(() => setTop), //编辑单元格的top值
  popupContainer: computed(() => getTbody1), //挂载容器
  setSelectContentStyle: setSelectContentStyle, //动态设置样式（8，9,10）
  setSelectStyleFn: setSelectStyleFn, //动态设置下拉框的高度
  setCellEditClassName: computed(() => setCellEditClassName.value) //编辑框样式
});
provide('provideFieldCom', {
  getPopContentWidth: computed(() => fieldEditComRef.value?.getPopWidth) //（8，9,10）
});
defineExpose({ updateClickType, closable });
</script>
<style scoped lang="less">
@import './index.less';
</style>
